import React from 'react'

export default () => (
  <div>
    Sorry, none of my skills match your search.
  </div>
)
